import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, mapTo } from 'rxjs/operators';
import { ForgotService } from '../services/forgot.service';
import { requestReset, requestResetSuccess, requestResetFailure } from './forgot.actions';

@Injectable()
export class ForgotEffects {
  requestReset$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(requestReset),
      map(action => action.payload),
      exhaustMap(payload => {
        return this.forgotService.requestPasswordReset$(payload).pipe(
          mapTo(requestResetSuccess()),
          catchError(({ error }: HttpErrorResponse) => {
            return of(requestResetFailure({ payload: error.message || error }));
          }),
        );
      }),
    );
  });

  constructor(private actions$: Actions, private forgotService: ForgotService) {}
}
